import { render, staticRenderFns } from "./LcChopSimple.vue?vue&type=template&id=331b5e36&"
import script from "./LcChopSimple.vue?vue&type=script&lang=js&"
export * from "./LcChopSimple.vue?vue&type=script&lang=js&"
import style0 from "./LcChopSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports